module.exports = __webpack_public_path__ + "img/DZ.732e2431.png";